// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App'
import Routers from './router'
import store from './store'
import qs from 'qs'
import util from './assets/js/util.js'
import "babel-polyfill"
require('./assets/css/site.css')
require('./assets/css/reset.css')

Vue.use(util)

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$qs = qs

const RouterConfig = {
  mode: 'history',
  routes: Routers,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
}

const router = new VueRouter(RouterConfig) // 实例化VueRouter

// 导航守卫，不加也可以
router.beforeEach((to, from, next) => {
  let browserTitle = to.meta.title
  store.commit('SET_BROWSERTITLE',browserTitle)
  next()
})

router.afterEach((to, from, next) => {
  window.document.title = store.state.browserTitle
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js